import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobal } from 'reactn';

const AddressBlockRO = (props) => {

    const { t } = useTranslation(['addressblock']);
    const [masterData] = useGlobal('masterData');
    const { businessPartner } = props;
    const { address } = props;
  
    const getCountryName = (countryId) => {
      return (masterData.countries.find(item => item.id===countryId) || {}).text;
    }
  
    return (
      <>
        <div className="column-8 offset-2">
          <h4>{t(props.addressTitle)}</h4>
        </div>
  
        <div className="column-8 offset-2">
          <div className="form-group">
            <label className="form-label">
              {businessPartner.FirstName} {businessPartner.Name}
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              {address.Street} {address.AddressAddition}
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              {address.PostalCode} {address.City}
            </label>
          </div>

          <div className="form-group">
            <label className="form-label">
              {getCountryName(address.refCountryId)}
            </label>
          </div>          
          
        </div>
      </>
    );
  }

  export default AddressBlockRO;